import React from "react";
import { Box, Typography, Button } from "@mui/material";

const PromoBanner = () => {
  return (
    <Box
      sx={{
        height: "300px",
        backgroundImage:
          "url('https://images.unsplash.com/photo-1524995997946-a1c2e315a42f')",
        backgroundSize: "cover",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        textAlign: "center",
      }}
    >
      <Box>
        <Typography variant="h4" mb={2}>
          Special Discount for Institutions
        </Typography>
        <Button variant="contained">Explore Now</Button>
      </Box>
    </Box>
  );
};

export default PromoBanner;